import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

const useScrollSpy = (sectionIds: string[]): void => {
  const router = useRouter()

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2
      let currentSection = ''

      for (const id of sectionIds) {
        const element = document.getElementById(id.split('#')[1])
        if (element) {
          const { offsetTop, offsetHeight } = element
          const rect = element.getBoundingClientRect();
          if ((rect.top >= 0 && rect.left >=0 && 
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && 
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)) || 
            (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight)) {
              currentSection = id 
              break
          }
        }
      }

      if (currentSection) {
        document.querySelectorAll('a').forEach((link) => {
          if (link.getAttribute('href') === `${currentSection}`) {
            link.classList.add('activeAnchorLink')
          } else {
            link.classList.remove('activeAnchorLink')
          }
        })
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [sectionIds, router])
}

export default useScrollSpy
